/*
 * Copyright (C) 2023 - present Marek Kuzora - All Rights Reserved.
 */


import Immutable from 'immutable';


export default (parent) =>
{
  let state = new Immutable.Map();

  for (const projectile of parent.getProjectilesFrom())
  {
    state = state.set(projectile.getKey(), projectile.getType());
  }

  return state;
}
